import { classNames } from '@utils/classNames';

type ParameterValueProps = {
  value: string;
  className?: string;
};

export const ParameterValue = ({ value, className }: ParameterValueProps) => {
  return value ? (
    <span
      className={classNames(
        'text-dark text-sm font-bold leading-normal font-outfit text-nowrap',
        className,
      )}
    >
      {value}
    </span>
  ) : null;
};
